export const CHAT_FEED_LIMIT = 6;

export function appendChatMessage<T>(messages: T[], message: T, limit = CHAT_FEED_LIMIT): T[] {
  return [...messages, message].slice(-Math.max(1, Math.floor(limit)));
}
